module.exports = __webpack_public_path__ + "img/c03_buildingtechheadhunting_Normal_ua.dbf15ab9.webp";